import styled from 'styled-components';

import { LAYOUT_CHROME } from '../../../../theme/tokens';

/* Wallet glyph wrapper — rest colour from the wallet-icon token; the parent nav
   item's active/hover `path[fill]` rule recolours it from here. The chrome's
   `.icon svg` / `.drawer-icon svg` rules size the inner svg. */
export const Glyph = styled.span`
  display: block;
  color: ${LAYOUT_CHROME.walletIcon};

  svg {
    display: block;
  }
`;
